import * as React from 'react';
import { usePage } from '@inertiajs/react';
import { assetUrl } from '../../utils/assetUrl';
import { route } from '../../utils/route';
import { trackSignupClicked } from '../../utils/tracking';

interface EduHeroProps {
  loginUrl: string;
  whatsappUrl: string;
}

export function EduHero({}: EduHeroProps) {
  const { cdnUrl } = usePage<{ cdnUrl: string }>().props;
  const heroImg = assetUrl(cdnUrl, '/img/edu-hero.webp');

  return (
    <section className="edu-hero">
      <style>{`
        .edu-hero {
          position: relative;
          background: url(${heroImg}) center center/cover no-repeat;
          padding: 100px 0 110px;
          min-height: 480px;
          display: flex;
          align-items: center;
        }
        .edu-hero::before {
          content: '';
          position: absolute;
          inset: 0;
          background: rgba(0, 0, 0, 0.62);
        }
        .edu-hero-inner {
          position: relative;
          z-index: 1;
          max-width: 800px;
          margin: 0 auto;
          padding: 0 24px;
          text-align: center;
        }
        .edu-hero h1 {
          font-size: 38px;
          font-weight: 800;
          color: #fff;
          margin: 0 0 16px;
          line-height: 1.2;
        }
        .edu-hero .hero-sub {
          font-size: 20px;
          color: rgba(255,255,255,0.9);
          margin: 0 0 12px;
          font-weight: 500;
        }
        .edu-hero .hero-desc {
          font-size: 17px;
          color: rgba(255,255,255,0.75);
          margin: 0 0 36px;
        }
        .edu-hero-ctas {
          display: flex;
          gap: 16px;
          justify-content: center;
          flex-wrap: wrap;
        }
        .edu-btn-primary {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 14px 28px;
          background: #1EAA25;
          color: #fff;
          font-size: 16px;
          font-weight: 600;
          border-radius: 8px;
          text-decoration: none;
          transition: background 0.2s;
        }
        .edu-btn-primary:hover {
          background: #178f1e;
          color: #fff;
          text-decoration: none;
        }
        .edu-btn-secondary {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 14px 28px;
          background: transparent;
          color: #fff;
          font-size: 16px;
          font-weight: 600;
          border: 2px solid rgba(255,255,255,0.6);
          border-radius: 8px;
          text-decoration: none;
          transition: all 0.2s;
        }
        .edu-btn-secondary:hover {
          background: rgba(255,255,255,0.1);
          border-color: #fff;
          color: #fff;
          text-decoration: none;
        }
        @media (max-width: 640px) {
          .edu-hero {
            padding: 70px 0 80px;
            min-height: auto;
          }
          .edu-hero h1 {
            font-size: 28px;
          }
          .edu-hero .hero-sub {
            font-size: 17px;
          }
          .edu-hero-ctas {
            flex-direction: column;
            align-items: stretch;
          }
          .edu-btn-primary, .edu-btn-secondary {
            justify-content: center;
          }
        }
      `}</style>
      <div className="edu-hero-inner">
        <h1>Frutas y verduras frescas para tu institución educativa</h1>
        <p className="hero-sub">Alimentar bien es parte de educar bien.</p>
        <p className="hero-desc">Abastecemos comedores escolares, jardines, colegios y universidades en Córdoba.</p>
        <div className="edu-hero-ctas">
          <a href={route('wholesale.pricing')} className="edu-btn-primary">
            <i className="fa fa-list-alt" /> Ver Precios Mayoristas
          </a>
          <a href={route('company.create')} className="edu-btn-secondary" onClick={() => trackSignupClicked('educacion', 'hero')}>
            <i className="fa fa-user-plus" /> Crear una cuenta
          </a>
        </div>
      </div>
    </section>
  );
}
